module.exports = __webpack_public_path__ + "assets/images/template/project/intro.jpg?v=e97ce7ac";